<template>
  <svg viewBox="0 0 600 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <text x="50%" y="82" text-anchor="middle" font-family="system-ui, -apple-system, sans-serif" font-size="100" font-weight="900" letter-spacing="2" fill="currentColor">HEYFOMO</text>
  </svg>
</template>
